module.exports = __webpack_public_path__ + "img/investment.07604549.svg";